import { renderCategory } from '../monetization/FilterList';

// 前端兜底筛选器
export const DEFAULT_SELECTOR = [
  {
    key: 'region',
    dataKey: 'region',
    default: {
      region_type: 'market',
      markets: ['255'],
      regions: [],
    },
    name_cn: '区域',
    name_en: 'Region',
  },
  {
    key: 'system',
    dataKey: 'system',
    default: ['255'],
    name_cn: '平台',
    name_en: 'Platform',
    view_type: "group"
  },
  {
    key: 'category',
    dataKey: 'category',
    default: {
      category_type: 'product',
      product: ['255'],
      category: ['255'],
    },
    name_cn: '产品',
    name_en: 'Product',
    render: renderCategory,
  },
  {
    key: 'zone',
    dataKey: 'zone',
    name_cn: 'Zone',
    name_en: '区服',
    default: ['255'],
  },
  {
    key: 'channel',
    dataKey: 'channel',
    default: ['255'],
    name_cn: '渠道',
    name_en: 'Channel',
  },
  {
    key: 'lang',
    dataKey: 'lang',
    default: ['255'],
    name_cn: '语言',
    name_en: 'Language',
  },
];
